"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import $ from "jquery";
import _ from "underscore";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  save: function(document, extras) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/documents/" + document.id,
        type: "PUT",
        contentType: "application/json",
        data: JSON.stringify(__spreadValues({
          document: _.omit(document, ["pages", "exception_events"])
        }, extras))
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  setAsCarrierDocument: function(document, carrierId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/documents/" + document.id,
        type: "PUT",
        contentType: "application/json",
        data: JSON.stringify({ carrier_id: carrierId })
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  setAssignedToCustomerLoad: function(document, customerLoadId, isAssigned) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/documents/" + document.id,
        type: "PUT",
        contentType: "application/json",
        data: JSON.stringify({
          customer_load_id: customerLoadId,
          is_assigned: isAssigned
        })
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  setAssignedToShipment: function(document, shipmentId, isAssigned) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/documents/" + document.id,
        type: "PUT",
        contentType: "application/json",
        data: JSON.stringify({
          shipment_id: shipmentId,
          is_assigned: isAssigned
        })
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  setAssignedToDelivery: function(documentId, deliveryId, assigned) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/documents/" + documentId + "/toggle_delivery_document",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          delivery_id: deliveryId,
          assigned
        })
      }).then(DataStoreService.responseHandler, _.identity)
    );
  }
};
